var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOk = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m9 14.59-2.29-2.3-1.42 1.42L9 17.41l9.71-9.7-1.42-1.42z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0m0 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10",
  className: "cls-1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ok.09fab16b20c31d9ddb5546252a30da04.svg";